import { Component } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './weave-loader.component.html',
    styleUrls: ['./weave-loader.component.scss']
})
export class WeaveLoaderComponent {

  constructor() { }

}
